import React, { memo } from 'react';
import { useSelector } from 'react-redux';
import { CompanyLocationMap, NoData } from '@components';
import { orangeDot, blueDot, redDot } from '@model';
// import '@style/modules/analysis/analysisRight.scss';
import '../../../../styles/modules/analysis/analysisRight.scss';

function Locations({ data, title }) {
  const { loc = [] } = data;

  const { buyerLabel, targetLabel } = useSelector(({ common }) => ({
    buyerLabel: common.projectCompanyInfo.buyerLabel,
    targetLabel: common.projectCompanyInfo.targetLabel,
  }));

  return (
    <div className="analysis-right-wrapper headquarter">
      <div className="title">{title}</div>
      {loc.every((obj) => obj.isManualInput) ? (
        <NoData />
      ) : (
        <div className="bottom">
          <CompanyLocationMap locationsInfo={loc} />
          <div className="map-legend">
            <img src={orangeDot} alt="buyer" />
            {buyerLabel}
            <img src={blueDot} alt="target" />
            {targetLabel}
            <img src={redDot} alt="mixure" />
            {buyerLabel}&{targetLabel}
          </div>
        </div>
      )}
    </div>
  );
}

export default memo(Locations);
